import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ExcelGeneratorService } from '../services/excelGenerator/excel-generator.service';
import { Observable } from 'rxjs';

@Injectable()
export class ExcelGeneratorRepository {
  constructor(private service: ExcelGeneratorService) {}

  public getExcel(data: Array<any>, fileName: string, filters?: HttpParams): Observable<any> {
    return this.service.getExcelFromBack(data, fileName, filters);
  }

  public getReport(data: Array<any>, fileName: string): Observable<any> {
    return this.service.getReportFromBack(data, fileName);
  }

  public getReportToExcel(data: Array<any>, filters?: HttpParams): Observable<any> {
    return this.service.getSalesTrialsExcel(data, filters);
  }
}
